<template>
  <dashboard-widget title="LAA DISTILLED" :zoomed="zoomed" :width="width" :enableDelete="enableDelete"
                      @zoom="$emit('zoom','DashboardDistillationHistory')"
                      @delete="$emit('delete','DashboardDistillationHistory')"
                      @close="$emit('close')"
                      xprint @print="print">

    <v-btn-toggle v-model="period" mandatory @change="refresh" style="position:absolute;top:40px;left:10px" :style="zoomed?'top:50px':''">
      <v-btn x-small value="Last30Days">Every 30 days</v-btn>
      <v-btn x-small value="Monthly">By month</v-btn>
    </v-btn-toggle>

    <div ref="chart" @click="disableTo ? '' : $router.push({name:'ProductionDistilling'})" style="position:relative;top:25px"/>
  </dashboard-widget>
</template>

<script>
import {format,add} from 'date-fns'
import printHtml from '@/mixins/printHtml'

export default {
  name: 'DashboardDistillationHistory',
  mixins: [printHtml],
  props: {
    from: {type:String, required:true},
    to: {type:String, required:true},
    zoomed: {type:Boolean, required:false, default:false},
    width: {type:Number, required:false, default:290},
    enableDelete: {type: Boolean, required:false, default:false},
    disableTo: {type: Boolean, required:false, default:false}
  },
  data() {
    return {
      chart: null,
      period: 'Last30Days',
      summary: [],
      options: {chartArea:{height:this.zoomed?'80%':'95%',width:'90%',left:40},
                fontSize:this.zoomed?12:10,
                height:this.zoomed?415:225,
                colors:['blue','green'],
                vAxis:{format: '#,###.0',gridlines:{count:3},minorGridLines:{count:0},viewWindowMode:"maximized"},
                hAxis:{textStyle:{color:this.zoomed?'black':'white'},showTextEvery:4},
                legend:{ position: "top", alignment:'center'}}
    }
  },
  computed: {
    drawer() {
      return this.$store.state.drawer;
    }
  },
  watch: {
    dark() {
      this.draw();
    },
    drawer() {
      this.draw();
    },
    from() {
      this.refresh();
    },
    to() {
      this.refresh();
    }
  },
  async mounted() {
    if (window.google) {
      window.google.charts.load('current', {'packages':['corechart']});
      window.google.charts.setOnLoadCallback(() => {
        if (this.$refs.chart == undefined)
          return;
        this.chart = new window.google.visualization.LineChart(this.$refs.chart);
        this.refresh();
      });
    }
  },
  methods: {
    async refresh() {
      const results = await this.$apiCall(`query DashboardDistillationHistory($from:Date!, $to:Date!, $period:SummaryPeriod!) {
                                            distillationSummary(from:$from, to:$to, period:$period) {
                                              totalLAA,netLAA,periodStart
                                            }
                                          }`, {from:this.from, to:this.to, period:this.period});
      if (!results.error) {
        this.summary = results.data.distillationSummary;
        this.draw();
      }
    },
    draw() {
      if (this.chart === null)
        return;

      const dataLineChart = [["Period","Total",{role:"tooltip",type:"string"},"Net",{role:"tooltip",type:"string"}]];

      const base = this.period === 'Monthly' ? new Date(format(new Date(), 'yyyy-MM') + '-01T00:00:00') : new Date();
      const dateFormat = this.period === 'Monthly' ? 'yyyy-MM' : 'yyyy-MM-dd';
      let range = 24;
			while (range--) {
        const date = format(add(base, this.period === 'Monthly' ? {months:-1*range} : {days:-30*range}), dateFormat);
        dataLineChart.push([date,0,this.date(date)+'\nTotal: 0 LAA',0,this.date(date)+'\nNet: 0 LAA']);
      }
      if (this.period !== 'Monthly')
        dataLineChart.splice(24, 1);

      for (const infoline of this.summary) {
        let index = 0;
        while (index < dataLineChart.length)
          if (dataLineChart[index][0] === infoline.periodStart) {
            const line = dataLineChart[index];
            line[1] = infoline.totalLAA;
            line[2] = this.date(line[0]) + "\nTotal: " + this.number(infoline.totalLAA) + " LAA";
            line[3] = infoline.netLAA;
            line[4] = this.date(line[0]) + "\nNet: " + this.number(infoline.netLAA) + " LAA";
            break;
          }
          else
            index++
			}
      const data = window.google.visualization.arrayToDataTable(dataLineChart);
      this.options.vAxis.textStyle = {color:this.darkMode?'#ffffff':'#3d3d3d'};
      this.options.vAxis.baselineColor = this.darkMode?'#ffffff':'#3d3d3d';
      this.options.width = this.zoomed ? 480 : this.width-30;
      this.chart.draw(data, {...this.options, backgroundColor:this.darkMode?'#1e1e1e':'white'});
    },
    date(d) {
      if (this.period === 'Monthly')
        return format(new Date(d+'-01T00:00:00'), 'MMMM yyyy');
      return this.$formatDate(d) + ' to ' + this.$formatDate(format(add(new Date(d+'T00:00:00'),{days:29}),'yyyy-MM-dd'));
    },
    number(n) {
      return this.$number(n, 0);
    },
    print() {
      this.printHtml('',`<style>
                        @page {size:portrait}
                        body {font-family: Roboto, sans-serif; font-size:14px}
                        .title {font-weight:700;font-size:18px;text-align:center;width:100%}
                        .sub-title {text-align:center;margin-bottom:16px,width:100%}
                      </style>
                      <div class="title">Distilled</div>
                      <div class="sub-title"></div>
                      <img id="graph"/>`,
                      {id:'graph', src:this.chart.getImageURI()});
    }
  }
}
</script>